/**
 * S-89: SignInCard の inline style。
 *
 * mfaStyles.ts と同じ方針: 各 app の Tailwind / CSS 変数の有無に依存せず一貫描画する
 * ため具体色を用いる。カード・フォームの基本要素は mfaStyles を再利用し、ここには
 * サインイン固有（ブランドヘッダー / 運用注記 / フッター）のみを置く。
 */
/** カード + フッターを縦に並べる外枠（mfaCardWrap の column 版）。 */
export const signInWrap = {
    display: 'flex',
    minHeight: '100vh',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '3rem 1rem',
    background: '#f4f4f6',
};
export const brandHeader = {
    textAlign: 'center',
};
export const brandLogo = {
    // S-89 dev FB: 160 → 240（1.5 倍）。maxWidth 70% でカード幅 352px 内に収まる
    width: 240,
    maxWidth: '70%',
    height: 'auto',
    display: 'inline-block',
};
export const brandTenantName = {
    margin: '0.75rem 0 0',
    fontSize: '0.8125rem',
    fontWeight: 600,
    color: '#6b7280',
};
/** アプリ名。tokens.css --primary（sky-600）と同系の具体色。 */
export const brandAppTitle = {
    margin: '0.25rem 0 0',
    fontSize: '1.125rem',
    fontWeight: 700,
    color: '#0284c7',
};
export const signInInput = {
    marginTop: '0.25rem',
    width: '100%',
    boxSizing: 'border-box',
    border: '1px solid #cdd0d8',
    borderRadius: 6,
    padding: '0.5rem 0.75rem',
    fontSize: '0.875rem',
};
export const signInFieldError = {
    margin: '0.25rem 0 0',
    fontSize: '0.75rem',
    color: '#dc2626',
};
/** アカウント発行 / パスワード再設定の運用注記。 */
export const signInAccountNote = {
    margin: '1rem 0 0',
    fontSize: '0.75rem',
    color: '#6b7280',
    lineHeight: 1.7,
};
export const signInFooter = {
    marginTop: '1.25rem',
    textAlign: 'center',
    fontSize: '0.6875rem',
    color: '#9ca3af',
    lineHeight: 1.8,
};
export const signInFooterLink = {
    color: '#6b7280',
    textDecoration: 'underline',
};
//# sourceMappingURL=signInStyles.js.map